import dadosAgenciaComum from './dadosAgenciaComum';

export const dadosDSousaPassagens = {
    ...dadosAgenciaComum,
    id: 'dsousapassagens',
    nome: "D' Sousa passagens",
    instagram: 'instagram.com',
    facebook: 'facebook.com',
    youtube: 'youtube.com',
    email: 'suportevexado@gmail.com',
    idsTagManager: ['GTM-TVMDLQQ']
};
